import React from 'react';
import axios from 'axios';
import { useEffect, useState } from 'react';
import Cookies from 'js-cookie';

import './AsciiNameApp.css';
const url = process.env.REACT_APP_URL_LOCAL;

const AsciiNameApp = () => {
	const [, setAsciiName] = useState('');

	useEffect(() => {
		const fetchAsciiName = async () => {
			try {
				const headers = {
					headers: {
						authorization: `Bearer ${Cookies.get('mazeToken')}`,
					},
				};
				const response = await axios.get(url + '/u-demos-ascii', headers);
				if (response.data.message === 'OK') {
					setAsciiName(response.data.ascii);
					const div = document.getElementById('asciiName');
					div.innerHTML = '<pre>' + response.data.ascii + '</pre>';
				}
			} catch (error) {
				console.log(error);
			}
		};
		fetchAsciiName();
	}, []);
	return (
		<>
			<section className="ascii-art-name">
				<div
					id="asciiName"
					style={{ color: 'green' }}
				></div>
			</section>
		</>
	);
};

export default AsciiNameApp;
